import React from 'react';
import {  useSelector } from 'react-redux';
import classNames from 'classnames';
import moment from 'moment';
import filter from 'lodash/filter';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThumbsUp } from '@fortawesome/sharp-solid-svg-icons/faThumbsUp';

import { faAward } from '@fortawesome/pro-solid-svg-icons/faAward';
import { faGem } from '@fortawesome/pro-solid-svg-icons/faGem';
import { faSparkles } from '@fortawesome/pro-solid-svg-icons/faSparkles';
import { faBolt } from '@fortawesome/pro-solid-svg-icons/faBolt';

import { t } from '../../../helpers/t';
import { Tooltip, useTooltip } from '../../Tooltip';

function getBadges({
  is_boosted,
  top_spaces_member,
  published_at,
  staff_pick,
  response_time_average,
  operated_by_storefront,
}) {
  const badges = {
    sponsored: {
      check: () => is_boosted,
      name: t('factories.listings.listingProperties.sponsored'),
      icon: faGem,
      class: 'bg-stone-800 text-white'
    },
    top_space: {
      check: () => top_spaces_member,
      name: t('factories.listings.listingProperties.topSpace'),
      icon: faAward,
      class: 'bg-amber-500 text-white',
      tooltip: t('factories.listings.listingProperties.topSpaceTooltip')
    },
    staff_pick: {
      check: () => staff_pick,
      name: t('factories.listings.listingProperties.staffPick'),
      icon: faThumbsUp,
      class: 'bg-blue-500 text-white'
    },
    new: {
      check: () => (moment().diff(published_at, 'days') <= 3),
      name: t('factories.listings.listingProperties.new'),
      icon: faSparkles,
      class: 'bg-blue-500 text-white'
    },
    fast_responder: {
      check: () => (response_time_average <= 60 * 60 * 4),
      name: t('factories.listings.listingProperties.fastResponder'),
      icon: faBolt,
      class: 'bg-teal-600 text-white',
      tooltip: (() => {
        const interval = moment.duration((response_time_average < 60 * 60) ? (60 * 60) : response_time_average, 'seconds').humanize();
        return t(`root.listings.${operated_by_storefront ? 'concierge' : 'owner'}.responseRate`, { interval });
      })()
    }
  };

  return filter(badges, function(badge) {
    return badge.check();
  });
}

export function ListingBadge({...props}) {
  const listing = useSelector((state) => state.listing);

  const badges = getBadges(listing);

  return badges.length > 0 && (
    <div {...props}>
      {
        badges.map((badge, index) => {
          const tooltip = badge.tooltip ? useTooltip() : null;

          return (
            <div key={`listing-badge-${badge.name}-${index}`} className={classNames(index < badges.length - 1 && 'mr-1', 'inline-flex items-center cursor-default')}>
              <div {...(tooltip ? { ref: tooltip.refs.setReference } : {})} className={classNames('text-xs font-normal px-2 py-0.5 rounded uppercase', badge.class)} {...(tooltip ? tooltip.getReferenceProps() : {})}>
                <FontAwesomeIcon icon={badge.icon} className={classNames(badge.name ? 'mr-1.5' : '', badge.icon)} />
                {badge.name}
              </div>
              {tooltip && <Tooltip {...tooltip}>
                <span dangerouslySetInnerHTML={{ __html: badge.tooltip }} />
              </Tooltip>}
            </div>
          );
        })
      }
    </div>
  );
}
